import { getFileNameFromUrl } from "%/mediaType";

/**
 * 문서(PDF·오피스·HWP 등) 첨부를 표시하는 파일 카드.
 * 이미지가 아니므로 <img> 로 렌더하지 않고 파일명 + 열기 링크로 표시한다.
 */
interface DocAttachmentProps {
  url: string;
  /** 카드 클릭 시 동작(미지정 시 새 탭으로 파일 열기) */
  onClick?: () => void;
  className?: string;
}

const extLabel = (name: string): string => {
  const dot = name.lastIndexOf(".");
  return dot >= 0 ? name.slice(dot + 1).toUpperCase() : "FILE";
};

const DocAttachment = ({ url, onClick, className }: DocAttachmentProps) => {
  const fileName = getFileNameFromUrl(url);
  const label = extLabel(fileName);

  const handleOpen = () => {
    if (onClick) {
      onClick();
      return;
    }
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <button
      type="button"
      onClick={handleOpen}
      title={fileName}
      className={
        "flex h-full w-full flex-col items-center justify-center gap-1 rounded-lg border border-gray-200 bg-gray-50 p-2 text-center transition-colors hover:bg-gray-100 " +
        (className || "")
      }
    >
      <svg
        className="h-8 w-8 text-orange-500"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <path d="M14 2v6h6" />
      </svg>
      <span className="w-full truncate px-1 text-[11px] font-medium text-gray-700">
        {fileName}
      </span>
      <span className="rounded bg-orange-100 px-1.5 text-[10px] font-semibold text-orange-600">
        {label}
      </span>
    </button>
  );
};

export default DocAttachment;
